import { useState } from "react";
import ToggleBtnGroup from "../../../components/ToggleBtnGroup/ToggleBtnGroup";
import B2bSettings from "./B2bSettings";
import BlockchainSettings from "./BlockchainSettings";

const TABS: string[] = ["Settings", "Blockchain Settings"];

export default function Settings() {
  const [tab, setTab] = useState(0);

  return (
    <div className="relative h-full mx-auto max-w-5xl">
      <ToggleBtnGroup
        className="mx-[90px]"
        items={TABS.map((t, idx) => ({ value: idx, label: t }))}
        selectedValue={tab}
        onSelectedValueChanged={setTab}
      />

      {!tab ? <B2bSettings /> : <BlockchainSettings />}
    </div>
  );
}
